import React from 'react';
import { Box } from '@spothero/ui';
// Reference: https://reactbits.dev/text-animations/gradient-text
export function GradientText({ children, colors = ['#52A8FB', '#ffffff', '#52A8FB', '#ffffff'], animationSpeed = 8, fontWeight = 'semibold', }) {
    const gradientStyle = {
        backgroundImage: `linear-gradient(to right, ${colors.join(', ')})`,
        animationDuration: `${animationSpeed}s`,
    };
    return (<Box position="relative" margin="0 auto" display="flex" maxWidth="fit-content" flexDirection="row" alignItems="center" justifyContent="center" borderRadius="1.25rem" fontWeight={fontWeight} backdropFilter="blur(10px)" transition="box-shadow 0.5s ease-out" overflow="visible" cursor="default" sx={{
            // Keyframes animation
            '@keyframes gradient': {
                '0%': {
                    backgroundPosition: '0% 50%',
                },
                '50%': {
                    backgroundPosition: '100% 50%',
                },
                '100%': {
                    backgroundPosition: '0% 50%',
                },
            },
        }}>
            <Box display="inline-block" position="relative" zIndex={2} color="transparent" sx={{
            backgroundSize: '300% 100%',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            backgroundImage: gradientStyle.backgroundImage,
            animation: `gradient ${gradientStyle.animationDuration} linear infinite`,
        }}>
                {children}
            </Box>
        </Box>);
}
